import Signin from '../../components/Signin'


export const SigninsPage=()=><Signin/>;
export default SigninsPage;